import { FC, useEffect, useState } from "react";
import { OpenApiRequestStatus, useOpenApiRequest } from "typescript-request-utils";

import { relationToString } from "../../../../api/enums/Relation";
import { UserCustomer } from "../../../../api/models/UserCustomer";
import { ViewType } from "../../../../page/enums/ViewType";
import { authorizedUsersTableColumns, customerAuthorizationsTableColumns } from "../../../configuration/tableColumns";
import { getApiRegistry } from "../../../state/apiRegistry";
import UserCustomerModal from "../../modal/UserCustomerModal";
import { MobileItemClosedIcon, MobileItemDeleteIcon, MobileItemOpenedIcon } from "../../table/rowIcons";
import { Column, ColumnItem, HeaderColumn, IconColumnItem, ItemWrapper } from "../mobileComponents";
import useCustomTranslation from "../../../../features/hooks/CustomUseTranslation";

export interface UserCustomerMobileProps {
    userCustomer: UserCustomer;
    type: ViewType;
    onUpdate: () => void;
}

const UserCustomerMobileItem: FC<UserCustomerMobileProps> = (props) => {
    const [showModal, setShowModal] = useState<boolean>(false);
    const [showFullItem, setShowFullItem] = useState<boolean>(false);
    const [deleteError, setDeleteError] = useState<boolean>(false);
    const [deleteUserCustomerPending, setDeleteUserCustomerPending] = useState<boolean>(false);

    const [deleteUserCustomerRequest, deleteUserCustomer] = useOpenApiRequest(getApiRegistry().userCustomerApi.delete);

    const { t } = useCustomTranslation();
    var startDate = props.userCustomer.startDate ? props.userCustomer.startDate.toLocaleDateString("fi-FI") : '';
    var endDate = props.userCustomer.endDate ? props.userCustomer.endDate.toLocaleDateString("fi-FI") : '';

    useEffect(() => {
        if (deleteUserCustomerRequest.type === OpenApiRequestStatus.Pending) {
            setDeleteUserCustomerPending(true);
        }
        if (deleteUserCustomerRequest.type === OpenApiRequestStatus.Complete) {
            setShowModal(false);
            setDeleteError(false);
            setDeleteUserCustomerPending(false);
            props.onUpdate();
        } else if (deleteUserCustomerRequest.type === OpenApiRequestStatus.NetworkError || deleteUserCustomerRequest.type === OpenApiRequestStatus.ServerError) {
            setDeleteError(true);
            setDeleteUserCustomerPending(false);
        }
        // eslint-disable-next-line
    }, [deleteUserCustomerRequest]);

    useEffect(() => {
        if (!showModal) {
            setDeleteError(false);
        }
    }, [showModal]);

    return (
        <div>
            {!showFullItem &&
                <ItemWrapper>
                    <Column>
                        <MobileItemClosedIcon onClick={() => setShowFullItem(true)} />
                    </Column>
                    <HeaderColumn>
                        <ColumnItem>{props.type === ViewType.AUTHORIZED_USERS ? t(authorizedUsersTableColumns[0].columnName) : t(customerAuthorizationsTableColumns[0].columnName)}</ColumnItem>
                    </HeaderColumn>
                    <Column>
                        <ColumnItem>{props.type === ViewType.AUTHORIZED_USERS ? props.userCustomer.user.username : props.userCustomer.customer?.customerNumber}</ColumnItem>
                    </Column>
                </ItemWrapper>
            }
            {showFullItem &&
                <ItemWrapper>
                    <Column>
                        <MobileItemOpenedIcon onClick={() => setShowFullItem(false)} />
                    </Column>
                    <HeaderColumn>
                        {props.type === ViewType.AUTHORIZED_USERS && authorizedUsersTableColumns.map((row, index) => row.columnName &&
                            <ColumnItem key={index}>{t(row.columnName)}</ColumnItem>)}
                        {props.type === ViewType.CUSTOMER_AUTHORIZATIONS && customerAuthorizationsTableColumns.map((row, index) => row.columnName &&
                            <ColumnItem key={index}>{t(row.columnName)}</ColumnItem>)}
                        <ColumnItem>{t("functions")}</ColumnItem>
                    </HeaderColumn>
                    <Column>
                        {props.type === ViewType.AUTHORIZED_USERS && <>
                            <ColumnItem>{props.userCustomer.user.username}</ColumnItem>
                            <ColumnItem>{props.userCustomer.customer?.customerNumber}</ColumnItem>
                            <ColumnItem>{props.userCustomer.customer?.name}</ColumnItem>
                            <ColumnItem>{startDate} - {endDate}</ColumnItem></>}
                        {props.type === ViewType.CUSTOMER_AUTHORIZATIONS && <>
                            <ColumnItem>{props.userCustomer.customer?.customerNumber}</ColumnItem>
                            <ColumnItem>{props.userCustomer.customer?.name}</ColumnItem>
                            <ColumnItem>{startDate} - {endDate}</ColumnItem>
                            <ColumnItem>{t(relationToString(props.userCustomer.relation))}</ColumnItem></>}
                        <IconColumnItem>
                            <MobileItemDeleteIcon onClick={() => setShowModal(true)} />
                        </IconColumnItem>
                    </Column>
                </ItemWrapper>
            }
            <UserCustomerModal
                show={showModal}
                userCustomer={props.userCustomer}
                showModal={setShowModal}
                handleClick={deleteUserCustomer}
                showError={deleteError}
                deleteUserCustomerPending={deleteUserCustomerPending} />
        </div>
    )
}

export default UserCustomerMobileItem;


